import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface SocialMediaLinksProps {
  instagramLink: string;
  tiktokLink: string;
  onInstagramChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTiktokChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({
  instagramLink,
  tiktokLink,
  onInstagramChange,
  onTiktokChange,
}) => {
  return (
    <>
      <div>
        <Label htmlFor="instagram_link">Instagram Profile URL</Label>
        <Input
          id="instagram_link"
          value={instagramLink}
          onChange={onInstagramChange}
          placeholder="https://instagram.com/yourusername"
        />
      </div>
      <div>
        <Label htmlFor="tiktok_link">TikTok Profile URL</Label>
        <Input
          id="tiktok_link"
          value={tiktokLink}
          onChange={onTiktokChange}
          placeholder="https://tiktok.com/@yourusername"
        />
      </div>
    </>
  );
};

export default SocialMediaLinks;